import i18n from "../../../i18n";

export const _basicInfo = (_mappedMetadata: any) => {
  return [
    ...(_mappedMetadata?.professionalAddress !== ' -'
      ? [{
        name: 'Διεύθυνση',
        value: '',
        refValue: 'professionalAddress',
      }] :
      []),
    ...(_mappedMetadata?.professionalTk !== '-'
      ? [{
        name: 'ΤΚ',
        value: '',
        refValue: 'professionalTk',
      }] :
      []),
    ...(_mappedMetadata?.professionalEmail !== '-'
      ? [{
        name: 'Email',
        value: '',
        refValue: 'professionalEmail',
      }] :
      []),
    ...(_mappedMetadata?.professionalWebsite !== '-'
      ? [{
        name: 'Website',
        value: '',
        refValue: 'professionalWebsite',
      }] :
      []),
    ...(_mappedMetadata?.professionalLinkedIn !== '-'
      ? [{
        name: 'LinkedIn',
        value: '',
        refValue: 'professionalLinkedIn',
      }] :
      []),
    ...(_mappedMetadata?.professionalVimeo !== '-'
      ? [{
        name: 'Vimeo',
        value: '',
        refValue: 'professionalVimeo',
      }] :
      []),
    ...(_mappedMetadata?.professionalYoutube !== '-'
      ? [{
        name: 'Youtube',
        value: '',
        refValue: 'professionalYoutube',
      }] :
      []),
    ...(_mappedMetadata?.professionalFacebook !== '-'
      ? [{
        name: 'Facebook',
        value: '',
        refValue: 'professionalFacebook',
      }] :
      []),
    ...(_mappedMetadata?.professionalInstagram !== '-'
      ? [{
        name: 'Instagram',
        value: '',
        refValue: 'professionalInstagram',
      }] :
      []),
    ...(_mappedMetadata?.professionalTwitter !== '-'
      ? [{
        name: 'Twitter',
        value: '',
        refValue: 'professionalTwitter',
      }] :
      []),
  ];
};

export const _usefulInfo = (_mappedMetadata: any) => {
  return [
    ...(_mappedMetadata?.professionalSpecialty !== '-'
      ? [{
        name: 'Ειδικότητα',
        value: '',
        refValue: 'professionalSpecialty',
      }]
      : []
    ),
    ...(_mappedMetadata?.servicesCategory !== '-'
      ? [{
        name: 'Κατηγορία Υπηρεσιών',
        value: '',
        refValue: 'servicesCategory',
      }]
      : []
    ),
    ...(i18n.language !== "el" && _mappedMetadata?.professionalProductionsEn !== '-'
      ? [{
        name: 'Παραγωγές που έχετε συμμετάσχει',
        value: '',
        refValue: 'professionalProductionsEn',
      }] :
      []),
    ...(_mappedMetadata?.communicationLanguages !== '-'
      ? [{
        name: 'Γλώσσες Επικοινωνίας',
        value: '',
        refValue: 'communicationLanguages',
      }] :
      []),
    ...(i18n.language !== "el" && _mappedMetadata?.professionalServicesEn !== '-'
      ? [{
        name: 'Περιγραφή Προσφερόμενων Υπηρεσιών και Ειδικότητας',
        value: '',
        refValue: 'professionalServicesEn',
      }] :
      []),
    ...(_mappedMetadata?.serviceAreas !== '-'
      ? [{
        name: 'Περιοχές Εξυπηρέτησης',
        value: '',
        refValue: 'serviceAreas',
      }] :
      []),
    ...(_mappedMetadata?.professionalsProd !== '-'
      ? [{
        name: 'Παραγωγές που έχει συμμετάσχει',
        value: '',
        refValue: 'professionalsProd',
      }] :
      []),
    ...(i18n.language !== "en" && _mappedMetadata?.professionalDescription !== '-'
      ? [{
        name: 'Περιγραφή',
        value: '',
        refValue: 'professionalDescription',
      }] :
      [])
  ];
};

export const _contactDetails = (_mappedMetadata: any) => {
  return [
    ...(_mappedMetadata?.businessName !== '-'
      ? [{
        name: 'Επωνυμία',
        value: '',
        refValue: 'businessName',
      }] :
      []),
    ...(_mappedMetadata?.professionalName !== '-'
      ? [{
        name: 'Όνομα',
        value: '',
        refValue: 'professionalName',
      }] :
      []),
    ...(_mappedMetadata?.professionalSurname !== '-'
      ? [{
        name: 'Επώνυμο',
        value: '',
        refValue: 'professionalSurname',
      }] :
      []),
    ...(_mappedMetadata?.vatCode !== '-'
      ? [{
        name: 'ΑΦΜ',
        value: '',
        refValue: 'vatCode',
      }] :
      []),
    ...(_mappedMetadata?.professionalPhone !== '-'
      ? [{
        name: 'Τηλέφωνο',
        value: '',
        refValue: 'professionalPhone',
      }] :
      []),
  ];
};

